import { render } from "./BaseNavbar.vue?vue&type=template&id=257145c0&scoped=true"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"

import "./BaseNavbar.vue?vue&type=style&index=0&id=257145c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257145c0"]])

export default __exports__